<template>
  <div class="relative h-43 rounded-md overflow-hidden min-w-72 transition-transform duration-300 hover:-translate-y-2">
    <!-- Imagem de fundo -->
    <img :src="props.imageurl ? props.imageurl: imageUrlDefault" :alt="props.name" class="absolute inset-0 w-full h-full object-cover object-center" />

    <!-- Overlay + link -->
    <ULink :to="`/categoria/${createSlug(props.name)}`"
      class="absolute inset-0 flex items-center justify-center bg-black/50 hover:bg-[#189083]/60 transition-colors duration-300">
      <h3 class="text-white text-shadow-md text-xl font-bold text-center px-4 ">
        {{ props.name }}
      </h3>
    </ULink>
  </div>
</template>
<script setup lang="ts">
import {createSlug} from "~/utils/strings";

interface Props {
  name: string;
  imageurl?: string | null;
}
const config = useRuntimeConfig()
const assetsPath = config.public.assetsPath

const imageUrlDefault: string = assetsPath + 'img_categories/capa-fic-mais-ifmg.jpg'

const props = defineProps<Props>();

</script>